/**
 * Shared class names for the compact hit job title (normalised title).
 * Actual styles live in hit-card.css to keep SRP HTML small.
 * Used by both HitCompactView (static SRP) and HitCompact (interactive).
 * Desktop/mobile visibility is controlled only by hit-card.css media queries.
 */
export const COMPACT_TITLE_LINK_CLASS_DESKTOP = 'hit-title-desktop';

export const COMPACT_TITLE_LINK_CLASS_MOBILE = 'hit-title-mobile';

export const COMPACT_TITLE_SUBTITLE_CLASS = 'hit-subtitle';

export const COMPACT_TITLE_SUBTITLE_CLASS_MOBILE = 'hit-subtitle-mobile';
